import { EntityModules } from 'core/constants';

export const entityNameField = (type: EntityModules): `${EntityModules}__name` => `${type}__name`;
